'use strict';

const INQUIRY_TYPE_ID = {
  FLAG_DECISION_MAKER: 1,
  FLAG_COMPANY: 2,
  SEARCH_MOBILE: 3,
  // SEARCH_DECISION_MAKER: 4, // unused on backend now ToDo: remove v1, v2
  COMPANY_INVESTIGATION: 9,
};

const INQUIRY_SUB_TYPE_ID = {
  DECISION_MAKER_FUNCTION: 1,
  DECISION_MAKER_EMAIL: 2,
  DECISION_MAKER_PHONE: 3,
  DECISION_MAKER_ASSISTANT: 4,
  DECISION_MAKER_LINKEDIN: 5,
  DECISION_MAKER_OTHER: 6,
  COMPANY_ADDRESS: 7,
  COMPANY_PHONE: 8,
  COMPANY_STRUCTURE: 9,
  COMPANY_FINANCIAL_DATA: 10,
  COMPANY_OTHER: 11,
  MOBILE_NUMBER: 12,
  COMPANY_SIREN_SIRET: 14,
  SEARCH_DECISION_MAKER: 15,
  COMPANY_ERROR_DATA: 16,
  DECISION_MAKER_SEARCH_MOBILE: 17,
  DECISION_MAKER_SEARCH_EMAIL: 18,
  MISSING_COMPANY_SEARCH: 19,
};

const STATUS_ID = {
  TODO: 1,
  IN_PROGRESS: 2,
  PRE_DONE: 3,
  DONE: 4,
  FAIL: 5,
  DRAFT: 6,
  PRE_FAIL: 7,
  PRE_PARTIALLY_DONE: 8,
  PARTIALLY_DONE: 9,
  PRE_EDITORIAL_OFFLINE: 10,
  EDITORIAL_OFFLINE: 11,
};

const OPTED_OUT = 'OPTED_OUT';

const INQUIRY_CONSTANTS = {
  INQUIRY_PER_PAGE_COUNT: 20,
  INQUIRY_SUB_TYPE_ID,
  INQUIRY_TYPE_ID,
  OPTED_OUT,
  STATUS_ID,
  INQUIRY_MAX_QUOTA: 15,
};

export {
  INQUIRY_CONSTANTS,
};
